import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import { TableCell } from '@cobliteam/ui/components/Table';
import Timeline, { TimelineContent, TimelineIcon, TimelineItem } from '@cobliteam/ui/components/Timeline';
import { format } from '@cobliteam/utils/date';

interface DateColumnProps {
  path: Path;
}

const DateColumn = ({ path }: DateColumnProps) => {
  const { startTime, endTime, type } = path;

  const startDate = format(new Date(startTime), 'HH:mm, dd/MM/yyyy');
  const endDate = format(new Date(endTime), 'HH:mm, dd/MM/yyyy');

  if (type === 'trip') {
    return (
      <TableCell>
        <Timeline>
          <TimelineItem separatorClassName='bg-primary'>
            <TimelineIcon color='primary'>A</TimelineIcon>
            <TimelineContent>{startDate}</TimelineContent>
          </TimelineItem>
          {endDate && (
            <TimelineItem separatorClassName='bg-primary'>
              <TimelineIcon color='primary'>B</TimelineIcon>
              <TimelineContent>{endDate}</TimelineContent>
            </TimelineItem>
          )}
        </Timeline>
      </TableCell>
    );
  }

  return (
    <TableCell>
      <Timeline>
        <TimelineItem className='items-center'>
          <TimelineIcon icon='pause' color='default' />
          <TimelineContent>
            <p>{startDate}</p>
            {endDate && <p>{endDate}</p>}
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </TableCell>
  );
};

export default DateColumn;
